// Display formatting helpers (Swedish locale, SEK).

const sek0 = new Intl.NumberFormat("sv-SE", { maximumFractionDigits: 0 });
const shares = new Intl.NumberFormat("sv-SE", { maximumFractionDigits: 0 });

/** Large money amounts (P&L, cost, value) — no decimals. */
export function fmtSek(value: number): string {
  return `${sek0.format(Math.round(value))} kr`;
}

/** Signed money, for gains/losses. */
export function fmtSekSigned(value: number): string {
  const sign = value > 0 ? "+" : "";
  return `${sign}${fmtSek(value)}`;
}

/** Price per share. Adaptive precision so penny stocks keep meaningful digits. */
export function fmtPrice(value: number): string {
  const abs = Math.abs(value);
  const decimals = abs < 1 ? 4 : abs < 10 ? 3 : 2;
  return `${value.toLocaleString("sv-SE", { minimumFractionDigits: decimals, maximumFractionDigits: decimals })} kr`;
}

/** Compact large numbers, e.g. volume: 22779229 -> "22,8 mn". */
export function fmtCompact(value: number): string {
  return new Intl.NumberFormat("sv-SE", { notation: "compact", maximumFractionDigits: 1 }).format(value);
}

export function fmtPct(value: number): string {
  const sign = value > 0 ? "+" : "";
  return `${sign}${value.toFixed(2)} %`;
}

export function fmtShares(value: number): string {
  return shares.format(value);
}

export function fmtRelativeTime(unixSeconds: number): string {
  const diff = Date.now() / 1000 - unixSeconds;
  if (diff < 60) return "nyss";
  if (diff < 3600) return `${Math.floor(diff / 60)} min sedan`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} h sedan`;
  return `${Math.floor(diff / 86400)} d sedan`;
}
